import { Base } from "./Base";

export interface City extends Base {
  code: number;
  name: string;
  provinceId: number;
  provinceName: string;
}

export const initCity: City = {
  id: -1,
  key: -1,
  code: -1,
  name: "",
  provinceId: -1,
  provinceName: "",
};
